export default class CompraProdutoCacheModel {
  public produtoId: string = "";
  public nome: string = "";
  public quantidade: number = 0;
  public precoUnitario: number = 0;
  public precoUnitarioDesconto: number = 0;
  public notas: string = "";
  public unidade: string = "";
  public fatorMultiplicacao: number = 1;

  public static toModel(item: any): CompraProdutoCacheModel {
    return {
      produtoId: item.productId,
      nome: item.title,
      quantidade: +item.quantity,
      precoUnitario: +item.unitPrice,
      precoUnitarioDesconto: +item.unitDiscountPrice,
      notas: item.notes,
      fatorMultiplicacao: +item.weightMultiplierFactor,
      unidade: item.saleUnit,
    } as CompraProdutoCacheModel;
  }

  public static toApi(item: CompraProdutoCacheModel): any {
    return {
      ProductId: item.produtoId,
      Title: item.nome,
      Quantity: item.quantidade,
      UnitPrice: item.precoUnitario,
      UnitDiscountPrice: item.precoUnitarioDesconto,
      Notes: item.notas,
      WeightMultiplierFactor: item.fatorMultiplicacao,
      SaleUnit: item.unidade,
    };
  }
}